import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/lib/services";
import { FadeUp } from "./Motion";

export function ServicesGrid({ limit }: { limit?: number }) {
  const items = limit ? SERVICES.slice(0, limit) : SERVICES;

  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {items.map((s, i) => (
        <FadeUp key={s.slug} delay={i * 0.05}>
          <Link
            to="/servicos/$slug"
            params={{ slug: s.slug }}
            className="group block h-full overflow-hidden rounded-2xl bg-gradient-card shadow-card transition-spring hover:-translate-y-1 hover:shadow-elegant"
          >
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src={s.image}
                alt={s.imageAlt}
                loading="lazy"
                width={1200}
                height={800}
                className="h-full w-full object-cover transition-spring group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/70 via-transparent to-transparent" />
            </div>
            <div className="p-5">
              <h3 className="font-display text-lg font-semibold text-foreground transition-smooth group-hover:text-primary">
                {s.shortTitle}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary">
                Saiba mais
                <ArrowRight className="h-4 w-4 transition-smooth group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        </FadeUp>
      ))}
    </div>
  );
}
